import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";

// styles
import styles from "./styles";

class RendTableBody extends Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
  };

  render() {
    const { children } = this.props;

    return <TableBody>{children}</TableBody>;
  }
}

export default withStyles(styles)(RendTableBody);
